import { useTranslation } from 'react-i18next'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Switch, Text } from '@reveni-io/reveni-ui'

import { blockDescriptions, blockLabels } from '../constants'
import * as Styles from '../styles'

const ContentBlockItem = ({ block, onToggle, disabled }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: block.identifier,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  const handleToggle = () => onToggle(block.identifier)

  return (
    <Styles.BlockItem ref={setNodeRef} style={style}>
      <DotsSixVerticalIcon size={24} id="draggable-icon" data-testid="draggable-icon" {...attributes} {...listeners} />
      <Switch checked={block.enabled} onChange={handleToggle} disabled={disabled} />
      <Styles.BlockTexts>
        <Text type="bodyMRegular">{t(blockLabels[block.identifier])}</Text>
        <Text type="bodySRegular" color={theme.colors.text.muted}>
          {t(blockDescriptions[block.identifier])}
        </Text>
      </Styles.BlockTexts>
    </Styles.BlockItem>
  )
}

export default ContentBlockItem
